define(["bluebird"], function(__WEBPACK_EXTERNAL_MODULE__17__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 429);
/******/ })
/************************************************************************/
/******/ ({

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(430);


/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PageReady", {
  enumerable: true,
  get: function get() {
    return _index.singleton;
  }
});

var _index = __webpack_require__(431);

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.singleton = void 0;

var _pageReady = _interopRequireDefault(__webpack_require__(432));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const singleton = new _pageReady.default();
exports.singleton = singleton;

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _bluebird = _interopRequireDefault(__webpack_require__(17));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const GLOBAL_PAGE = '';

class PageReady {
  /**
   * Constructor
  */
  constructor() {
    this.p$pagesReady = {};
    this.resolvePageReadyCbs = {};
  }
  /**
   * Mark the page as ready. This will resolve the promise
   * and initialize all the delayed components.
   * @param {String} pageName page name, default is global/any page
   * @returns {void}
  */


  pageIsReady(pageName = GLOBAL_PAGE) {
    this.lazyInitializePromise(pageName);
    this.resolvePageReadyCbs[pageName](); // Also mark the global page as ready if any page is ready

    if (pageName !== GLOBAL_PAGE && this.resolvePageReadyCbs[GLOBAL_PAGE]) {
      this.resolvePageReadyCbs[GLOBAL_PAGE]();
    }
  }
  /**
   * Returns a promise that will resolve when the page is ready.
   * Listeners can use this function to delay execution until the page is ready.
   * @param {String} pageName page name, default is global/any page
   * @returns {Promise} - Promise that is resolved when the page is marked as ready.
   */


  afterPageReady(pageName = GLOBAL_PAGE) {
    this.lazyInitializePromise(pageName);
    return this.p$pagesReady[pageName];
  }
  /**
  * Lazily create the promise if it doesn't already exist
  * @private
  * @param {String} pageName page name, default is global/any page
  * @returns {void}
  */


  lazyInitializePromise(pageName = GLOBAL_PAGE) {
    if (this.p$pagesReady[pageName]) {
      return;
    }

    this.p$pagesReady[pageName] = new _bluebird.default(res => {
      this.resolvePageReadyCbs[pageName] = res;
    }); // Also initialize the global promise since it's tied to any page

    if (pageName !== GLOBAL_PAGE && !this.p$pagesReady[GLOBAL_PAGE]) {
      this.p$pagesReady[GLOBAL_PAGE] = new _bluebird.default(res => {
        this.resolvePageReadyCbs[GLOBAL_PAGE] = res;
      });
    }
  }

}

exports.default = PageReady;

/***/ })

/******/ })});;
